var schema = {
  title: "Form Selection",
  description: "Form Selection",
  type: "object",
  required: ["region", "insuredPolicyNumber", "insuredName", "insuredtel", "clientEmail", "brokerage", "brokeremail", "claimtypeCat", "claimtype"],
  properties: {
    region: {
      type: "string",
      title: "Region",
      enum: ["Gauteng", "Cape Town"]
    },
    insuredPolicyNumber: {
      type: "string",
      title: "Policy Number"
    },
    insuredName: {
      type: "string",
      title: "Insured Name and Surname"
    },
    insuredtel: {
      type: "string",
      title: "Insured Contact Number",
      minLength: 10
    },
    clientEmail: {
      type: "string",
      title: "Insured Email",
      format: "email"
    },
    brokerage: {
      type: "string",
      title: "Brokerage"
    },
    brokerName: {
      type: "string",
      title: "Broker Contact Person"
    },
    brokeremail: {
      type: "string",
      title: "Broker Email",
      format: "email"
    },
    claimtypeCat: {
      type: "string",
      title: "What type of incident you want to submit claim for?",
      enum: ["Motor", "Non-motor"]
    },
    claimtype: {
      type: "string",
      title: "Item you want to submit claim for"
    },
    claimMotor: {
      type: "string",
      title: "Motor item you want to submit claim for",
      enum: ["Motor Vehicle Windscreen", "Vehicle Stolen or Hijacked", "Accident Collision"]
    },
    claimNonMotor: {
      type: "string",
      title: "Non-motor item you want to submit claim for",
      enum: ["Geyser", "Property Loss or Damage", "Public Liability"]
    }
  },
  dependencies: {
    claimMotor: {
      oneOf: [{
        properties: {
          claimMotor: {
            enum: ["Accident Collision"]
          },
          thirdparty: {
            type: "object",
            title: "Third Party",
            required: ["thirdpartyInvolved"],
            properties: {
              thirdpartyInvolved: {
                type: "string",
                title: "Was there a Third Party Involved in the Incident?",
                enum: ["Yes", "No"]
              }
            },
            dependencies: {
              thirdpartyInvolved: {
                oneOf: [{
                  properties: {
                    thirdpartyInvolved: {
                      enum: ["Yes"]
                    },
                    thirdpartyOther: {
                      type: "object",
                      title: "",
                      required: ["thirdpartyHaveDetails"],
                      properties: {
                        thirdpartyHaveDetails: {
                          type: "string",
                          title: "Do you have Third Party Details?",
                          enum: ["Yes", "No"]
                        }
                      },
                      dependencies: {
                        thirdpartyHaveDetails: {
                          oneOf: [{
                            properties: {
                              thirdpartyHaveDetails: {
                                enum: ["No"]
                              },
                              thirdpartyHaveDetailsNote: {
                                type: "null",
                                title: "When you receive third party information, please submit to your broker as it's required for claim processing."
                              }
                            }
                          }, {
                            properties: {
                              thirdpartyHaveDetails: {
                                enum: ["Yes"]
                              }
                            }
                          }]
                        }
                      }
                    }
                  }
                }, {
                  properties: {
                    thirdpartyInvolved: {
                      enum: ["No"]
                    }
                  }
                }]
              }
            }
          }
        }
      }]
    }
  }
};
export default schema;